module.exports = __webpack_public_path__ + "img/Logout.8664f09a.svg";